import styled from 'styled-components';
import Color from 'color';

const LinkText = styled.a`
  color: ${p => p.theme.colorPrimary};
  cursor: pointer;
  display: block;
  font-family: ${p => p.theme.fontFamily};
  font-weight: 400;
  height: auto;
  line-height: 22px;
  text-align: ${p => (p.style.textAlign ? p.style.textAlign : 'center')};
  margin: 5px;

  &:hover {
    color: ${p => Color(p.theme.colorPrimary)
    .alpha(0.85)
    .string()};
  }

  &:active {
    color: ${p => Color(p.theme.colorPrimary)
    .darken(0.15)
    .string()};
  }
`;

LinkText.defaultProps = {
  style: {},
  size: null,
};

export default LinkText;

// import styled from 'styled-components';

// export default styled.a`
//   font-size: 11px;
//   color: white;
//   text-decoration: none;
// `;



// WEBPACK FOOTER //
// ./src/components/text/LinkText/index.js